<div class="loading" *ngIf="isLoading"><img src="/assets/img/loader-logo.png" alt=""></div>
<div *ngIf="blankRequested; then blank; else main"></div>
<ng-template #blank>
  <router-outlet></router-outlet>
</ng-template>
<ng-template #main>
  <div class="body-wrapper">
    <app-navbar></app-navbar>
    <main class="page-body">
      <router-outlet></router-outlet>
    </main>
  </div>
</ng-template>

<div *ngIf="showInstallPopup" class="install-popup">
  <div class="popup-content">
    <button class="close-btn" (click)="closeInstallPopup()">×</button>
    <h2>Install Our App</h2>
    <p *ngIf="isAndroid()">
      Tap "Add to Home Screen" to install our app and get the best experience.
    </p>
    <p *ngIf="isIos()">
      To install on iOS, tap the Share icon → "Add to Home Screen".
    </p>
    <p *ngIf="isDesktop()">
      To install on Windows, click the "Add to Home Screen" button in your browser menu.
    </p>
    <button class="pop-up-btn" (click)="isIos() ? onIosInstallClick() : onInstallClick()">
      {{ isIos() ? 'Install on iOS' : 'Install on Android/Windows' }}
    </button>
  </div>
</div>
